'use client';

import { MultiSelectDropdown } from '@repo/ui/OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '@repo/ui/OffersFilter/useFilterEvents';
import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../store';
import { useMinBalanceFilterOptions } from '../store/hooks';

export const MinBalanceSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  isBankBonusesFilterExperiment,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  isBankBonusesFilterExperiment?: boolean;
}) => {
  const options = useMinBalanceFilterOptions();
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleChange = useCallback(
    (selectedLabels: string[]) => {
      if (scrollBackToMainBar) scrollBackToMainBar();
      setTimeout(
        () => {
          handleUpdateFilterFormState({ selectedMinBalanceRanges: selectedLabels });
          const newState = handleApplyFilters();
          if (!newState) return;
          updateFiltersEvent({
            additional_attributes: { min_balance: selectedLabels },
          });
        },
        scrollBackToMainBar ? 100 : 0,
      );
    },
    [handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent, scrollBackToMainBar],
  );

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Minimum Balance"
      options={options}
      selectedOptions={appliedFilters?.selectedMinBalanceRanges || []}
      onChange={handleChange}
      useStore={useOffersFilterStore}
      isBankBonusesFilterExperiment={isBankBonusesFilterExperiment}
    />
  );
};
